import {Routes} from '@angular/router'
import {AdminGuard} from '@/app/core/auth/guards/admin.guard'

export const AdminRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./admin-shell/admin-shell.page').then((m) => m.AdminShellPage),
        canActivate: [AdminGuard],
        canMatch: [AdminGuard],
        children: [
            // Gestión: tablero con las categorías del panel (pestaña «Gestión» en teléfono, acordeón en el menú lateral)
            {
                path: 'menu',
                loadComponent: () => import('./admin-menu/admin-menu.page').then((m) => m.AdminMenuPage),
            },

            // Perfil del administrador: tema (claro/oscuro) y cerrar sesión (botón de perfil en Gestión)
            {
                path: 'profile',
                loadComponent: () => import('./admin-profile/admin-profile.page').then((m) => m.AdminProfilePage),
            },

            // Verificación de empresas: cola de revisión de documentos y catálogo de documentos exigibles
            {
                path: 'company-documents',
                loadComponent: () =>
                    import('./company-documents/pages/admin-document-review/admin-document-review.page').then(
                        (m) => m.AdminDocumentReviewPage
                    ),
            },
            {
                path: 'document-types',
                loadComponent: () =>
                    import('./company-documents/pages/admin-document-types/admin-document-types.page').then(
                        (m) => m.AdminDocumentTypesPage
                    ),
            },

            // Companies
            {
                path: 'companies',
                loadComponent: () =>
                    import('./companies/pages/admin-companies/admin-companies.page').then(
                        (m) => m.AdminCompaniesPage
                    ),
            },
            {
                path: 'companies/:companyId',
                loadComponent: () =>
                    import('./companies/pages/admin-company-detail/admin-company-detail.page').then(
                        (m) => m.AdminCompanyDetailPage
                    ),
            },
            {
                path: 'companies/:companyId/edit',
                loadComponent: () =>
                    import('./companies/pages/admin-company-edit/admin-company-edit.page').then(
                        (m) => m.AdminCompanyEditPage
                    ),
            },

            // Branch detail
            {
                path: 'branches/:branchId',
                loadComponent: () =>
                    import('./branches/pages/admin-branch-detail/admin-branch-detail.page').then(
                        (m) => m.AdminBranchDetailPage
                    ),
            },

            // Branch Edit
            {
                path: 'branches/:branchId/edit',
                loadComponent: () =>
                    import('./branches/pages/admin-branch-edit/admin-branch-edit.page').then(
                        (m) => m.AdminBranchEditPage
                    ),
            },

            // ✅ Vista A: empleados de una sucursal (reusa EmployeeContainerPage)
            // /admin/branches/:branchId/employees
            {
                path: 'branches/:branchId/employees',
                loadComponent: () =>
                    import('@/app/domains/auth/employee/pages/employee-container/employee-container.page').then(
                        (m) => m.EmployeeContainerPage
                    ),
            },

            // ✅ Detalle empleado dentro de sucursal (reusa EmployeeRoutes)
            {
                path: 'branches/:branchId/employees/:employeeId',
                loadChildren: () => import('@/app/routes/employee.routes').then((m) => m.EmployeeRoutes),
            },

            // ✅ Vista B: empleados globales (reusa EmployeeContainerPage)
            // /admin/employees
            {
                path: 'employees',
                loadComponent: () =>
                    import('@/app/domains/auth/employee/pages/employee-container/employee-container.page').then(
                        (m) => m.EmployeeContainerPage
                    ),
            },

            // ✅ Roles (crear)
            // /admin/roles/create
            {
                path: 'roles/create',
                loadComponent: () =>
                    import('./roles/pages/admin-create-role/admin-create-role.page').then(
                        (m) => m.AdminCreateRolePage
                    ),
            },

            // ✅ Roles (editar)
            // /admin/roles/:roleId/edit
            {
                path: 'roles/:roleId/edit',
                loadComponent: () =>
                    import('./roles/pages/admin-role-edit/admin-role-edit.page').then(
                        (m) => m.AdminRoleEditPage
                    ),
            },

            // ✅ Roles (permisos)
            // /admin/roles/:roleId/permissions
            {
                path: 'roles/:roleId/permissions',
                loadComponent: () =>
                    import('./roles/pages/admin-role-permissions/admin-role-permissions.page').then(
                        (m) => m.AdminRolePermissionsPage
                    ),
            },

            // ✅ Roles (detalle / vista)
            // /admin/roles/:roleId
            {
                path: 'roles/:roleId',
                loadComponent: () =>
                    import('./roles/pages/admin-role-view/admin-role-view.page').then(
                        (m) => m.AdminRoleViewPage
                    ),
            },

            // /admin/roles
            {
                path: 'roles',
                loadComponent: () =>
                    import('./roles/pages/admin-roles/admin-roles.page').then((m) => m.AdminRolesPage),
            },

            // ✅ Detalle empleado global (reusa EmployeeRoutes)
            // /admin/employees/:employeeId/(view|edit|addresses...)
            {
                path: 'employees/:employeeId',
                loadChildren: () => import('@/app/routes/employee.routes').then((m) => m.EmployeeRoutes),
            },

            // Reportes — panel de operación del ERP (empresas, usuarios, soporte)
            {
                path: 'reports',
                loadComponent: () =>
                    import('./reports/pages/admin-reports/admin-reports.page').then(
                        (m) => m.AdminReportsPage
                    ),
            },

            {
                path: 'catalog',
                loadComponent: () =>
                    import('./catalog/pages/admin-catalog/admin-catalog.page').then(
                        (m) => m.AdminCatalogPage
                    ),
            },
            {
                path: 'catalog/attribute-builder',
                loadComponent: () =>
                    import('./catalog/pages/admin-attribute-builder/admin-attribute-builder.page').then(
                        (m) => m.AdminAttributeBuilderPage
                    ),
            },
            {
                path: 'catalog/attribute-builder/:attributeUid',
                loadComponent: () =>
                    import('./catalog/pages/admin-attribute-builder/admin-attribute-builder.page').then(
                        (m) => m.AdminAttributeBuilderPage
                    ),
            },
            {
                path: 'catalog/categories',
                loadComponent: () =>
                    import('./catalog/pages/admin-categories/admin-categories.page').then(
                        (m) => m.AdminCategoriesPage
                    ),
            },
            {
                path: 'catalog/attributes',
                loadComponent: () =>
                    import('./catalog/pages/admin-attributes/admin-attributes.page').then(
                        (m) => m.AdminAttributesPage
                    ),
            },
            {
                path: 'catalog/attribute-options',
                loadComponent: () =>
                    import('./catalog/pages/admin-attribute-options/admin-attribute-options.page').then(
                        (m) => m.AdminAttributeOptionsPage
                    ),
            },
            {
                path: 'catalog/measure-types',
                loadComponent: () =>
                    import('./catalog/pages/admin-measure-types/admin-measure-types.page').then(
                        (m) => m.AdminMeasureTypesPage
                    ),
            },
            {
                path: 'catalog/measures',
                loadComponent: () =>
                    import('./catalog/pages/admin-measures/admin-measures.page').then(
                        (m) => m.AdminMeasuresPage
                    ),
            },
            {
                path: 'catalog/category-attribute-rules',
                loadComponent: () =>
                    import('./catalog/pages/admin-category-attribute-rules/admin-category-attribute-rules.page').then(
                        (m) => m.AdminCategoryAttributeRulesPage
                    ),
            },

            // ✅ Panel Fiscal SII — protegido por AdminGuard
            // /admin/fiscal
            {
                path: 'fiscal',
                loadComponent: () =>
                    import('./fiscal/admin-fiscal.page').then(
                        (m) => m.AdminFiscalPage
                    ),
            },
            {
                path: 'fiscal/onboarding',
                loadComponent: () =>
                    import('./fiscal/onboarding-wizard/onboarding-wizard.component').then(
                        (m) => m.OnboardingWizardComponent
                    ),
            },

            // Solicitudes marketplace
            {
                path: 'marketplace-requests',
                loadComponent: () =>
                    import('./marketplace-requests/pages/admin-marketplace-requests/admin-marketplace-requests.page').then(
                        (m) => m.AdminMarketplaceRequestsPage
                    ),
            },
            {
                path: 'marketplace-requests/account-deletion/marketplace',
                loadComponent: () =>
                    import('./marketplace-requests/pages/admin-account-deletion-requests/admin-account-deletion-requests.page').then(
                        (m) => m.AdminAccountDeletionRequestsPage
                    ),
                data: { target: 'marketplace' },
            },
            {
                path: 'marketplace-requests/account-deletion/erp',
                loadComponent: () =>
                    import('./marketplace-requests/pages/admin-account-deletion-requests/admin-account-deletion-requests.page').then(
                        (m) => m.AdminAccountDeletionRequestsPage
                    ),
                data: { target: 'erp' },
            },
            {
                path: 'marketplace-requests/customers',
                loadComponent: () =>
                    import('./marketplace-requests/pages/admin-customers/admin-customers.page').then(
                        (m) => m.AdminCustomersPage
                    ),
            },

            // Moderación — comentarios reportados y lista negra de usuarios
            {
                path: 'moderation',
                loadComponent: () =>
                    import('./moderation/pages/admin-moderation/admin-moderation.page').then(
                        (m) => m.AdminModerationPage
                    ),
            },
            {
                path: 'moderation/reported-comments',
                loadComponent: () =>
                    import('./moderation/pages/admin-comment-reports/admin-comment-reports.page').then(
                        (m) => m.AdminCommentReportsPage
                    ),
            },
            {
                path: 'moderation/blacklist',
                loadComponent: () =>
                    import('./moderation/pages/admin-blacklist/admin-blacklist.page').then(
                        (m) => m.AdminBlacklistPage
                    ),
            },

            // Default
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'companies',
            },
        ],
    },
]
